import {useEffect, useState} from "react";
import {useDispatch} from "react-redux";
import lscache from "lscache";

import {SHOW_PUBLIC_TRANSPORT_ON_MAP} from "../../app/constants/storage_keys";
import {savePublicTransportChoice} from "../actions/user_map_preferences_actions";

export const useMapPublicTransportUserPreferences = () => {
    const [hasUserBeenAskForPublicTransport, setHasUserBeenAskForPublicTransport] = useState(true);
    const dispatch = useDispatch();

    useEffect(() => {
        const userMapTransportChoice = lscache.get(SHOW_PUBLIC_TRANSPORT_ON_MAP);

        if (userMapTransportChoice === null) {
            setHasUserBeenAskForPublicTransport(false);
        } else {
            // according to: https://coda.io/d/rynekpierwotny-pl_dvgFv_CLq19/Dodanie-modala-na-mapie-informujacego-o-mozliwosci-w-aczenia-wal_suffo#_luCDo
            // by default map should not show public transport
            dispatch(savePublicTransportChoice(false));
        }
    }, []);

    const saveUserMapTransportChoice = (showPublicTransportOnMap: boolean) => {
        dispatch(savePublicTransportChoice(showPublicTransportOnMap));
        setHasUserBeenAskForPublicTransport(true);
        lscache.set(SHOW_PUBLIC_TRANSPORT_ON_MAP, showPublicTransportOnMap);
    };

    return {
        hasUserBeenAskForPublicTransport,
        saveUserMapTransportChoice
    };
};
import {useEffect, useState} from "react";
import {useDispatch} from "react-redux";
import lscache from "lscache";

import {SHOW_PUBLIC_TRANSPORT_ON_MAP} from "../../app/constants/storage_keys";
import {savePublicTransportChoice} from "../actions/user_map_preferences_actions";

export const useMapPublicTransportUserPreferences = () => {
    const [hasUserBeenAskForPublicTransport, setHasUserBeenAskForPublicTransport] = useState(true);
    const dispatch = useDispatch();

    useEffect(() => {
        const userMapTransportChoice = lscache.get(SHOW_PUBLIC_TRANSPORT_ON_MAP);

        if (userMapTransportChoice === null) {
            setHasUserBeenAskForPublicTransport(false);
        } else {
            // according to: https://coda.io/d/rynekpierwotny-pl_dvgFv_CLq19/Dodanie-modala-na-mapie-informujacego-o-mozliwosci-w-aczenia-wal_suffo#_luCDo
            // by default map should not show public transport
            dispatch(savePublicTransportChoice(false));
        }
    }, []);

    const saveUserMapTransportChoice = (showPublicTransportOnMap: boolean) => {
        dispatch(savePublicTransportChoice(showPublicTransportOnMap));
        setHasUserBeenAskForPublicTransport(true);
        lscache.set(SHOW_PUBLIC_TRANSPORT_ON_MAP, showPublicTransportOnMap);
    };

    return {
        hasUserBeenAskForPublicTransport,
        saveUserMapTransportChoice
    };
};
